export const ROUTES = {
	requestContact: '/request-contact',
	intro: '/intro',
	root: '/',
	serviceError: '/service-error',

	subscriptionPaymentOptions: '/subscription-payment-options',
	subscriptionSelectAccount: '/subscription-select-account',
	subscriptionCorporateData: '/subscription-corporate',
	subscriptionIntegratorData: '/subscription-integrator',
	subscriptionTermsAndConditionsBank: '/subscription-terms-and-conditions-bank',
	subscriptionResumeAndAuthorization: '/subscription-resume-and-authorization',
	subscriptionConclusion: '/subscription-conclusion',
	accessDenied: '/accessDenied',
};

export type Routes = keyof typeof ROUTES;

export const subscriptionFlowPathCompany = [
	ROUTES.subscriptionPaymentOptions,
	ROUTES.subscriptionSelectAccount,
	ROUTES.subscriptionCorporateData,
	ROUTES.subscriptionIntegratorData,
	ROUTES.subscriptionTermsAndConditionsBank,
	ROUTES.subscriptionResumeAndAuthorization,
	ROUTES.subscriptionConclusion,
];
//TO ADD NEW FLOW ARRAY
export const subscriptionFlowPathIziBizi = [
	ROUTES.subscriptionPaymentOptions,
	ROUTES.subscriptionSelectAccount,
	ROUTES.subscriptionCorporateData,
	ROUTES.subscriptionTermsAndConditionsBank,
	ROUTES.subscriptionResumeAndAuthorization,
	ROUTES.subscriptionConclusion,
];

export const noFlowPath = [ROUTES.requestContact, ROUTES.intro, ROUTES.accessDenied];
